import React, { useState, useEffect  } from 'react';
import TextField from '@mui/material/TextField';
import setTitleAction from '../../redux/actions/createReferenceActions/actionTitle';
import { styled } from '@mui/system';
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next';


const StyledTextField = styled(TextField)({
        "&:hover ": {
            borderColor: "rgb(0,191,255)"
        },
        '& label.Mui-focused': {
            color: 'white'
        },
        "& .Mui-focused ": {
            color: 'white'
        },
        '& .MuiOutlinedInput-root': {

            '&:hover fieldset': {
                borderColor: 'rgb(0,191,255)',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'rgb(47, 79, 79)',
            },
        },
  });
  

export default function TitleForm(props) {

    const titleError = useSelector(state => state.createRefState.titleError)
    const selectedReferenceData = useSelector(state => state.showRefState.selectedReferenceData)
    const [title, setTitle] = useState("");
    const dispatch = useDispatch()
    const { t } = useTranslation();
      
    useEffect(() => {
        
        if(selectedReferenceData && window.location.href.indexOf('/editRef') > -1) {
            setTitle(selectedReferenceData.title);
        } 
      },[]);

      useEffect(() => {
        
        dispatch(setTitleAction(title))

      },[title]);

    const handleChange = (event) => {
        
        setTitle(event.target.value);

        }

    return (
        <div>
          <StyledTextField value={title} inputProps={{ maxLength: 30 }} label={t('create_ref.title') + "*"} variant="outlined" error={titleError} 
             style={{ width: 300, marginTop: 10, fontSize: 30, backgroundColor: 'rgba(19, 174, 236, 0.54)' }} onChange={handleChange}/>
        </div>
      );
}